import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
}

const listVBCAccountSlice = createSlice({
    name:"listVBCAccount",
    initialState: initialState,
    reducers: {
        getListVBCAccount(state, action){
            return {
                isLoading: true,
            }
        },
        getListVBCAccountSuccess(state, action){
            return {
                isLoading: false,
                data: action?.payload
            }
        },
        getListVBCAccountFailure(state, action){
            return {
                isLoading: false,
            }
        },
        cleanListVBCAccount(state, action){
            return{
                isLoading: false,
            }
        }
    }
})

export const { getListVBCAccount, getListVBCAccountFailure, getListVBCAccountSuccess, cleanListVBCAccount } = listVBCAccountSlice.actions

export default listVBCAccountSlice.reducer